import * as config from '../../../home24/core/config';

export function AppearQueue() {

    var queue = [];
    var currencyCode = '';

    // noinspection JSUnusedGlobalSymbols
    this.self = {
        /**
         * Method set current currency symbol for whole queue
         * @param {String} value
         */
        setCurrencyCode: function (value) {
            currencyCode = value;
        },
        getQueue: function () {
            return queue;
        },

        /**
         * Method initializes queue, starts interval timer
         */
        init: function () {
            (function (that) {
                setInterval(function () {
                    that.checkQueue();
                }, config.getInt('tracking.appearQueueInterval'));
            })(this);
        },

        /**
         * Push article appearance into queue
         * @param {Object} oData
         */
        push: function (oData) {
            queue.push(oData);
        },

        checkQueue: function () {
            if (queue.length > 0) {
                this.pushQueue();
            }
        },

        pushQueue: function () {

            var tmpQueue;
            var retVal = {};

            // noinspection JSUnresolvedVariable
            if (typeof window.dataLayer !== 'undefined') {

                tmpQueue = queue;
                queue = [];

                retVal.event = 'productImpressions';
                retVal.ecommerce = {};
                retVal.ecommerce.currencyCode = currencyCode;
                retVal.ecommerce.impressions = tmpQueue;

                // noinspection JSUnresolvedVariable
                window.dataLayer.push(retVal);
            }
        }
    };
}

/**
 * Queue used for grouping article appearance events and passing them to Google Tag Manager
 * @see REBOOT-14809
 */

var object = new AppearQueue();

object.self.init();

export function setCurrencyCode(value) {
    return object.self.setCurrencyCode(value);
}
export function push(oData) {
    return object.self.push(oData);
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/appearQueue.js
 **/